<template>
  <a href="javascript:void(0)" @click="toTop()" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-nav_chevron_up"></span></a>
</template>

<script>
  export default {
    name: 'btn-to-top',
    methods: {
      toTop (){
        this.$jQuery('html, body').animate({
          scrollTop: 0
        }, 800);
      }
    }    
  }
</script>
